module.exports = __webpack_public_path__ + "static/media/rockporch-logo-new.a0b95b41.svg";